<div class="map-container">
    @if (apiLoaded | async) {
    <google-map #map class="map" fxLayout="column" [center]="MapCenter" [zoom]="Zoom">
        @if (Marker) {
        <map-marker [position]="MapCenter"></map-marker>
        }
    </google-map>

    @if (isDrawing) {
    <div class="drawing-overlay" (click)="onOverlayClick($event)" (dblclick)="onOverlayDblClick($event)"
        (mousemove)="onOverlayMouseMove($event)"></div>
    }
    <div class="map-button-overlay">
        <div fxLayout="row" fxLayoutAlign="space-around center">

            <forge-icon-button variant="raised" [hidden]="isDrawing || hasShape" (click)="onDrawClick()"
                aria-label="Draw a shape" telemetry="Submission-DrawShape" class="map-button">
                <forge-tooltip placement="bottom">Draw a shape</forge-tooltip>
                <!-- Draw a shape -->
                <forge-icon name="draw"></forge-icon>
            </forge-icon-button>

            <forge-icon-button variant="raised" [hidden]="!isDrawing" (click)="onDrawCancel()"
                aria-label="Cancel Drawing" telemetry="Submission-CancelDraw" class="map-button">
                <forge-tooltip placement="bottom">Cancel Drawing</forge-tooltip>
                <!-- Draw a shape -->
                <forge-icon name="close"></forge-icon>
            </forge-icon-button>

            <forge-icon-button variant="raised" [hidden]="!hasShape" (click)="onSearchClick()"
                aria-label="Search in shape" telemetry="Submission-SearchMap" class="map-button">
                <forge-tooltip placement="bottom">Search in shape</forge-tooltip>
                <!-- Search in shape -->
                <forge-icon name="search"></forge-icon>
            </forge-icon-button>

            <forge-icon-button variant="raised" [hidden]="!hasShape" (click)="onClearShapeClick()"
                aria-label="Clear shape" telemetry="Submission-ClearShape" class="map-button">
                <forge-tooltip placement="bottom">Clear shape</forge-tooltip>
                <!-- Clear shape -->
                <forge-icon name="clear"></forge-icon>
            </forge-icon-button>
        </div>
    </div>
    }
</div>